import { Dispatch, ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";

import { ApplicationState } from "../redux/ApplicationState";

export const resetStates: ActionCreator<
  ThunkAction<void, ApplicationState, Record<string, never>, any>
> = (actionType: string, field?: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: actionType,
      field
    });
  };
};
